<template>
  <div ref="embedRef">
    <component
      :is="resolveComponent(`page-${_kebabCase(section.type)}`)"
      :id="`section-${section.id}`"
      :key="section.id"
      :data="{
        ...section.data,
        primaryColor: route.query?.primaryColor ? `#${route.query.primaryColor}` : section.data?.primaryColor,
      }"
      :guest="guest"
      :event="event"
      :stats="stats"
      :page-id="route.query?.p"
      :workspace="useWorkspaceStore().$state"
      :embed-params="{
        verticalSpacing: route.query?.verticalSpacing,
        backgroundColor: route.query?.backgroundColor ? `#${route.query.backgroundColor}` : undefined,
      }"
      @refresh-stats="refreshStats"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
  guest: {
    type: Object,
    default: null,
  },
  template: {
    type: Object,
    required: true,
  },
  lang: {
    type: String,
    required: true,
  },
});

// Computed
const route = useRoute();
const section = computed(() => props.event.pages?.activeTemplate?.sections.find((section) => section.type === route.query?.embed || section.id === route.query?.embed));

const embedRef = ref(null);

// Send height to parent window (iframe)
const sendHeight = () => {
  if (!embedRef.value) return;
  const height = embedRef.value.scrollHeight;
  window.parent.postMessage({
    sectionId: section.value.id,
    eventId: props.event._id,
    templateId: props.template._id,
    lang: props.lang,
    payload: {
      height,
    },
  }, '*');
};

useResizeObserver(embedRef, () => {
  sendHeight();
});

onMounted(() => {
  sendHeight();
});
</script>
